import React from 'react';
import MediaDetailsLeftSide from '../../components/MediaDetailsLeftSide/MediaDetailsLeftSide';
import MediaDetailsRightSide from '../../components/MediaDetailsRightSide/MediaDetailsRightSide';
import { useTranslation } from 'react-i18next';
import SEOHead from '../../components/SEO/SEOHead';
import { getMediaAlternates } from '../../utils/seoMappings';
import { shouldNoindexMediaPost } from '../../utils/seoIndexing';

const MediaDetailsArea = ({ postData }) => {
   const { i18n } = useTranslation();
   if (!postData?.length) {
      return null;
   }

   const alternates = getMediaAlternates(postData[0].mediaid, i18n.language);

   return (
      <>
         <section className="blog-area pt-50 pb-80">
            <div className="header-info position-absolute d-md-none flex" style={{ top: 65 }}>
               <a href="tel:+903125574646"> <span><i className="fas fa-phone"></i> +90 312 557 46 46</span></a>
               <a href="tel:+905332691271"> <span><i className="fas fa-phone"></i> +90 533 269 12 71</span></a>
            </div>
            <SEOHead
               title={`${postData[0].title} | Doç. Dr. Ebru Karagün`}
               description={postData[0].content.metaDescription}
               image={postData[0].image}
               canonicalPath={i18n.language === 'en' ? `/en/media/${postData[0].mediaid}` : `/medyada-biz/${postData[0].mediaid}`}
               trPath={alternates.trId ? `/medyada-biz/${alternates.trId}` : null}
               enPath={alternates.enId ? `/en/media/${alternates.enId}` : null}
               noindex={shouldNoindexMediaPost(postData[0].mediaid)}
            />
            <div className="container">
               <div className="row">

                  <MediaDetailsLeftSide postData={postData[0]} details_topBar={<div className="postbox__thumb mb-35">
                     <img src={postData[0]?.image} alt={postData[0]?.title} />
                  </div>} />

                  <MediaDetailsRightSide pdflink={postData[0]?.pdflink} medialink={postData[0]?.medialink} />

               </div>
            </div>
         </section>
      </>
   );
};

export default MediaDetailsArea;
